import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import './Gallery.css';

const Gallery = () => {
  const images = [
    { src: require('../assets/store1.JPG'), alt: 'Store Front View' },
    { src: require('../assets/store2.JPG'), alt: 'Store Interior' },
    { src: require('../assets/store3.JPG'), alt: 'Store Display' },
    { src: require('../assets/store4.JPG'), alt: 'Store Seating' },
    { src: require('../assets/store5.JPG'), alt: 'Store Counter' },
    { src: require('../assets/bagel.JPG'), alt: 'Fresh Bagel' },
    { src: require('../assets/crossiant.JPG'), alt: 'Croissant' },
    { src: require('../assets/crossiant2.JPG'), alt: 'Croissant Selection' },
    { src: require('../assets/crossiant3.JPG'), alt: 'Croissant Display' },
    { src: require('../assets/crossiant4.JPG'), alt: 'Croissant Variety' },
    { src: require('../assets/fruit-skewers.JPG'), alt: 'Fruit Skewers' },
    { src: require('../assets/mini-burger1.JPG'), alt: 'Mini Burgers' },
    { src: require('../assets/mini-burger2.JPG'), alt: 'Mini Burger Selection' },
    { src: require('../assets/pie.JPG'), alt: 'Fresh Pie' },
    { src: require('../assets/sushi.JPG'), alt: 'Sushi Platter' },
    { src: require('../assets/sushi2.JPG'), alt: 'Sushi Selection' },
    { src: require('../assets/wraps.JPG'), alt: 'Fresh Wraps' },
    { src: require('../assets/IMG_3900.JPG'), alt: 'Food Display' },
    { src: require('../assets/IMG_3902.JPG'), alt: 'Food Selection' },
    { src: require('../assets/IMG_4659.JPG'), alt: 'Food Presentation' },
    { src: require('../assets/c1.JPG'), alt: 'Cabinet 1' },
    { src: require('../assets/c2.JPG'), alt: 'Cabinet 2' },
    { src: require('../assets/c3.JPG'), alt: 'Cabinet 3' },
    { src: require('../assets/c4.JPG'), alt: 'Cabinet 4' },
    { src: require('../assets/c5.JPG'), alt: 'Cabinet 5' },
    { src: require('../assets/c6.JPG'), alt: 'Cabinet 6' },
    { src: require('../assets/c7.JPG'), alt: 'Cabinet 7' },
    { src: require('../assets/c8.JPG'), alt: 'Cabinet 8' },
  ];

  return (
    <div className="gallery-page">
      <Navigation />
      <div className="gallery-content">
        <div className="gallery-header">
          <Link to="/">
            <img src={require('../assets/FH_Logo-on-LG-Green.png')} alt="Forage Hill Cafe" className="gallery-logo" />
          </Link>
          <h2>Our Gallery</h2>
        </div>
        <div className="gallery-grid">
          {images.map((image, index) => (
            <div key={index} className="gallery-item">
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
